import { MARKETPLACE_CODE_PRINT_ON_DEMAND, MARKETPLACE_CODE_READY_TO_SELL } from 'shared/constants/marketplace'

export const getMarketplaceItemUrl = (uuid, isCustomizable = false) => {
  const marketplaceCode = isCustomizable
    ? MARKETPLACE_CODE_PRINT_ON_DEMAND
    : MARKETPLACE_CODE_READY_TO_SELL
  return `/marketplace/${marketplaceCode}/${uuid}`
}

export const getAlibabaProductUrl = (baseUrl) => {
  if (!baseUrl) return undefined
  const url = new URL(baseUrl)
  url.searchParams.set('channel', 'dropship')
  url.searchParams.set('src', 'modalyst')
  return url.toString()
}
